<template>
  <section class="content-padding-gray">
    <div class="row mt-3 text-center">
      <div class="col-12">
        <img src="/static/img/logo.png" alt="logo" class="img-fluid">
      </div>
    </div>

    <transition name="mode-fade" mode="out-in" @after-enter="afterEnter">

      <div v-if="!isRequestingOtp" key="notRequestingOtp">
        <h2 class="text-center mt-3">ยินดีต้อนรับ</h2>

        <form @submit.prevent="submitRequestOtp" v-if="$router && !$route.query.access_token">

          <div class="row justify-content-center">
            <div class="col-md-4 col-12">
              <div class="form-group">
                <input type="number" required v-model="phone" min="0"
                       class="form-control" placeholder="เบอร์โทรศัพท์">
              </div>
            </div>
          </div>

          <div class="row justify-content-center">
            <div class="col-md-4 col-12">
              <div class="form-group">
                <button class="btn btn-block -cyan" :disabled="isSubmittingRequestOtp"
                        type="submit">
                  <i v-if="isSubmittingRequestOtp" class="fas fa-circle-notch fa-spin"></i> ยืนยันเบอร์โทรศัพท์
                </button>
              </div>
            </div>
          </div>

        </form>
      </div>

      <div v-else key="isRequestingOtp" class="text-center">
        <p class="mt-3">เราได้ส่งรหัสผ่านไปที่ SMS เบอร์โทร {{ phone }} <br> กรุณายืนยันรหัสผ่านที่คุณได้รับ</p>

        <form @submit.prevent="submitLogin">
          <div class="col">
            <div class="row justify-content-center">
              <div class="col-md-4 col-12">
                <div class="form-group">
                  <input type="number" required v-model="otpPassword" ref="otpPassword" min="0"
                        class="form-control" placeholder="ระบุรหัสผ่านที่ได้รับ">
                </div>
                <div class="row-cols-1 text-right text-small" v-if="showResendOtp">
                  <span class=" text-black-50">ยังไม่ได้รับรหัสยืนยัน </span> 
                  <button  class="btn btn-link text-small"
                    style="padding:0px;"
                    @click.prevent="submitRequestOtp()" :disabled="!canSubmitResendOtp"><u>ขอรหัสผ่านอีกครั้ง</u></button>
                    <span class="text-black-50">({{ countDown }} วินาที )</span>
                </div>
                
              </div>
            </div>
          </div>

          <div class="row justify-content-between" style="margin-top:70px;">
            <div class="col-6 col-md-4 text-left">
              <button class="btn btn-secondary" type="button" @click.prevent="backward"><i class="fas fa-arrow-left"></i> ย้อนกลับ</button>
            </div>

            <div class="col-6 col-md-4 text-right">
              <button class="btn -cyan" type="submit">
                <i v-if="!isSubmittingOtp" class="fas fa-sign-in-alt"></i>
                <i v-else class="fas fa-circle-notch fa-spin"></i>
                ยืนยันรหัสผ่าน
              </button>
            </div>
          </div>

        </form>
      </div>

    </transition>


    <div class="row" v-if="errorMessage">
      <div class="col-12 text-center">
        <h4 class="text-danger">{{ errorMessage }}</h4>
      </div>
    </div>

  </section>
</template>

<script>
import axios from 'axios'

export default {
  name: 'Login',
  data () {
    return {
      phone: '',
      otpPassword: '',
      isRequestingOtp: false,
      isSubmittingRequestOtp: false,
      isSubmittingOtp: false,
      errorMessage: '',
      showResendOtp: false,
      countDown: 60,
      canSubmitResendOtp: false
    }
  },
  methods: {
    backward () {
      this.otpPassword = ''
      this.isRequestingOtp = false
      this.isSubmittingRequestOtp = false
      this.isSubmittingOtp = false
    },
    async submitRequestOtp () {
      this.canSubmitResendOtp = false
      this.countDown = 60
      this.isSubmittingRequestOtp = true
      const { data } = await axios.post('/professional/request-otp', {
        phone: this.phone
      })
      this.isSubmittingRequestOtp = false
      this.$forceUpdate()
      if (data.error) {
        this.$swal({
          type: 'error',
          title: 'ผิดพลาด',
          text: data.message,
          confirmButtonText: 'ปิด'
        })
        return false
      }

      this.isRequestingOtp = true
      this.showResendOtp = true
      this.countDownTimer()
      // setTimeout(() => {
      //   this.showResendOtp = true
      // }, 3000)
    },
    countDownTimer () {
      if (this.countDown > 0) {
        setTimeout(() => {
          this.countDown -= 1
          this.countDownTimer()
        }, 1000)
      } else {
        this.canSubmitResendOtp = true
      }
    },
    async submitLogin () {
      this.isSubmittingOtp = true
      const submitData = {
        phone: this.phone,
        otp_password: this.otpPassword
      }

      try {
        await this.$store.dispatch('auth/LOGIN_PROFESSIONAL', submitData)
        this.isSubmittingOtp = false
        this.$forceUpdate()
      } catch (err) {
        this.isSubmittingOtp = false
        this.$forceUpdate()
        console.log('error login professional', err)

        this.$swal({
          type: 'error',
          title: 'ผิดพลาด',
          text: err.message,
          confirmButtonText: 'ปิด'
        })
        return false
      }

      if (this.$route.query.redirect_to) {
        this.$router.push({ name: this.$route.query.redirect_to })
      } else {
        this.$router.push({ name: 'Professional With Holding Tax' })
      }
    },
    afterEnter () {
      // เมื่อ transition ทำงานเสร็จให้ focus input otp ทันที
      if (this.isRequestingOtp) {
        this.$nextTick(() => this.$refs.otpPassword.focus())
      }
    },
    async checkToken (token) {
      this.$swal({
        title: 'ระบบกำลังประมวลผล',
        text: 'กรุณารอสักครู่',
        allowOutsideClick: true
      })
      const { data } = await axios.post('/professional/' + this.$route.query.professional_id + '/me', {
        access_token: token
      })
      this.$swal.close()
      if (data.error) {
        this.errorMessage = data.message
        this.$swal({ text: data.message, type: 'error' })
      } else {
        let payload = {
          professional: data.professional,
          access_token: this.$route.query.access_token,
          token_temporary: data.token_temporary
        }
        await this.$store.dispatch('auth/LOGIN_BYPASS_PROFESSIONAL', payload)

        if (this.$route.query.redirect_to) {
          this.$router.push({ name: this.$route.query.redirect_to })
        } else {
          this.$router.push({ name: 'Professional With Holding Tax' })
        }
      }
    }
  },
  mounted () {
    this.errorMessage = ''
    this.otpPassword = ''
  },
  created () {
    let token = this.$route.query.access_token
    if (token) {
      this.checkToken(token)
    }
  }
}
</script>

<style scoped>
.mode-fade-enter-active, .mode-fade-leave-active {
  transition: opacity .5s ease
}

.mode-fade-enter-from, .mode-fade-leave-to {
  opacity: 0
}
</style>



// WEBPACK FOOTER //
// src/components/professional/Login.vue